import { render, staticRenderFns } from "./main_Head.vue?vue&type=template&id=2f9bd8fb&scoped=true"
import script from "./main_Head.vue?vue&type=script&lang=js"
export * from "./main_Head.vue?vue&type=script&lang=js"
import style0 from "./main_Head.vue?vue&type=style&index=0&id=2f9bd8fb&prod&scoped=true&lang=less"
import style1 from "./main_Head.vue?vue&type=style&index=1&id=2f9bd8fb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9bd8fb",
  null
  
)

export default component.exports